import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Spinner } from "@krea/shared/design-system/Spinner";

import { useCurrentLenderCompanyStore } from "../lender-companies/current-lender-company-store";
import { useGetMyLenderCompaniesQuery } from "../lender-companies/hooks/use-get-my-lender-companies.query";
import { useGetMeQuery } from "../users/hooks/use-get-me.query";

export const LenderApplicationRedirectPage = () => {
  const { id } = useParams();
  const { data: me } = useGetMeQuery();
  const companiesQuery = useGetMyLenderCompaniesQuery(
    {
      limit: 2,
      offset: 0,
    },
    {
      enabled: !!me,
    },
  );
  const currentLenderCompanyId = useCurrentLenderCompanyStore(
    (state) => state.lenderCompanyId,
  );
  const setCurrentLenderCompany = useCurrentLenderCompanyStore(
    (state) => state.setCurrentLenderCompany,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (me?.isAdmin) {
      navigate("/select-lender-company");

      return;
    }

    if (currentLenderCompanyId) {
      navigate(
        `/lender-company/${currentLenderCompanyId}/lender-application/${id}`,
      );

      return;
    }

    if (companiesQuery.data?.pages[0]?.items.length === 1) {
      const lenderCompanyId = companiesQuery.data.pages[0].items[0]?.id;
      if (lenderCompanyId) {
        setCurrentLenderCompany(lenderCompanyId);
        navigate(`/lender-company/${lenderCompanyId}/lender-application/${id}`);
      } else navigate("/select-lender-company");
    }

    if (
      companiesQuery.data?.pages[0]?.items.length &&
      companiesQuery.data.pages[0].items.length > 1
    ) {
      navigate("/select-lender-company");
    }
  }, [
    companiesQuery.data,
    currentLenderCompanyId,
    id,
    me?.isAdmin,
    navigate,
    setCurrentLenderCompany,
  ]);

  return (
    <div className="flex h-full items-center justify-center">
      <Spinner iconClassName="size-10" />
    </div>
  );
};
